import StepperType from './StepperType';
import Stepper, { IProps } from './Stepper';
import stepperStyles from './stepper.module.scss';

export type { IProps as IStepperProps };
export { Stepper, StepperType, stepperStyles };

export default Stepper;
